export default {
  filters: {
    separateDigit3(value) {
      return Number(value).toLocaleString('ja-JP', {
        style: 'decimal',
      })
    }
  }
}
